import { updateScrollElements } from "./animateTextOnScroll";

const selectors = {
  slide: '.js-home-hero-slide',
  text: '.home-hero-slide__reveal',
};

const handleHomeHero = () => {
  const slides = document.querySelectorAll(selectors.slide);
  if(!slides) return;

  const revealTexts = [...document.querySelectorAll(selectors.text)];
  const className = 'home-hero-slide__reveal--active';

  const changeSlides = () => {
    const active = [...slides].find(slide => slide.classList.contains('is-active'));
    const next = active?.nextElementSibling || slides[0];
    active?.classList.remove('is-active');
    next.classList.add('is-active');

    const revealText = next.querySelector(selectors.text);
    revealTexts.forEach((item) => item.classList.remove(className));
    revealText?.classList.add(className);
  };

  // changeSlides();
  updateScrollElements();
  setInterval(changeSlides, 5000);
}

export default handleHomeHero;
